<template>
    <div class="wrapper">
        <dash-header></dash-header>
        <sidebar></sidebar>
        <div class="content-wrapper">
            <!-- Content Header (Page header) -->
            <section class="content-header">
                <div class="container-fluid">
                    <div class="row mb-2">
                        <div class="col-sm-6">
                            <h1 class="m-0 title">Subscriptions</h1>
                        </div><!-- /.col -->
                        <div class="col-sm-6">
                            <ol class="breadcrumb float-sm-right">
                                <li class="breadcrumb-item"><router-link to="/dash">Home</router-link></li>
                                <li class="breadcrumb-item active">Subscriptions</li>
                            </ol>
                        </div><!-- /.col -->
                    </div><!-- /.row -->

                </div><!-- /.container-fluid -->
            </section>
            <!-- /.content-header -->

            <section class="content subs">
                <div>
                    <select class="form-control w-select" id="selectongkir" v-model="datafilter">
                        <option value="" disabled>Pilih Filter</option>
                        <option value="INITIAL_LICENSE">Initial License</option>
                        <option value="SUBSCRIPTION_RENEWAL">Subscription Renewal</option>

                    </select>
                </div>
                <div class="container-fluid">
                    <div class="row">
                        <div class="col-lg-12 connectedSortable">
                            <h5 class="title  mt-3">Pending Order</h5>

                            <h5 class="text-mude" v-if="filterPending.length < 1 && !loading && !loadingsub">
                                No Pending Order Available.
                            </h5>

                            <swiper ref="pendSwiper" :options="swiperOptions" v-else-if="filterPending.length > 0">
                                <swiper-slide v-for="list in filterPending" :key="list.id">
                                    <div class="card card_robot">
                                        <div class="card-body">
                                            <figure class="robot_img">
                                                <img :src="list.product_image" alt="">
                                            </figure>
                                            <div class="text">
                                                <h6 class="name">{{ list.product_name }}</h6>

                                                <div class="row">
                                                    <div class="col-6">
                                                        <p class="info">Status</p>
                                                        <p class="info_text">
                                                            <span class="badge badge-success"
                                                                v-if="list.status == 'SUCCESS'">{{ list.status }}</span>
                                                            <span class="badge badge-warning" v-else>{{ list.status
                                                                }}</span>
                                                            <!-- <span class="badge badge-success" v-else>{{product.status ? product.status : '-'}}</span> -->
                                                        </p>
                                                    </div>
                                                    <div class="col-6">
                                                        <p class="info">Product Type</p>
                                                        <p class="info_text type_text"
                                                            v-if="list.product_type == 'FUND_MANAGER'">
                                                            FUND MANAGER
                                                        </p>
                                                        <p class="info_text type_text" v-else>
                                                            {{ list.product_type }}
                                                        </p>
                                                    </div>
                                                    <div class="col-6">
                                                        <p class="info">Broker</p>
                                                        <p class="info_text">{{ list.broker_name }}</p>
                                                    </div>
                                                    <div class="col-6">
                                                        <p class="info">Risk Level</p>
                                                        <p class="info_text">
                                                            <span class="badge badge-danger"
                                                                v-if="list.risk_level == 3">HIGH</span>
                                                            <span class="badge badge-warning"
                                                                v-else-if="list.risk_level == 2">MEDIUM</span>
                                                            <span class="badge badge-success" v-else>LOW</span>
                                                        </p>
                                                    </div>
                                                    <div class="col-12" v-if="list.broker_account_id !== null">
                                                        <p class="info">Transaction Code :</p>
                                                        <p class="info_text type_text">{{ list.transaction_code }}</p>
                                                        <p class="info">Transaction Date :</p>
                                                        <p class="info_text type_text">{{ formatDate(list.created_at) }}
                                                        </p>
                                                    </div>
                                                    <div class="col-12">
                                                        <p class="info">Payment Amount</p>
                                                        <!-- <h3 class="price" v-if="list.payment_amount.length>=13">{{list.payment_amount.subString(0,13) + '...'}}</h3> -->
                                                        <h3 class="price">Rp {{ formatPrice(list.payment_amount) }}</h3>
                                                        <!-- <p class="desc">Lorem ipsum dolor sit amet consectetur adipisicing elit. Rerum, doloremque.</p> -->
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="button">
                                                <div v-if="list.broker_account_id == null" @click="sendIdTrans(list)">
                                                    <router-link :to="'robot/' + list.product_id + '/broker/'"
                                                        v-if="list.product_type == 'ROBOT'"
                                                        class="btn btn_outline_red btn-block">Select
                                                        Broker</router-link>
                                                    <router-link :to="'fund-manager/' + list.product_id + '/broker/'"
                                                        v-else class="btn btn_outline_red btn-block">Select
                                                        Broker</router-link>
                                                </div>
                                                <router-link :to="'/payment/' + list.id"
                                                    v-else-if="list.payment_amount !== 0 && list.activation_code == null && list.status !== 'SUCCESS' && list.status !== 'CANCELED'"
                                                    class="btn btn_grey btn-block">Waiting Payment
                                                    Verification</router-link>
                                                <button
                                                    v-else-if="list.status === 'CANCELED' && list.payment_url !== null"
                                                    class="btn btn_grey btn-block">
                                                    Payment Expired
                                                </button>
                                                <button
                                                    v-else-if="list.status === 'CANCELED' && list.payment_url == null"
                                                    class="btn btn_grey btn-block">
                                                    Cancel by System
                                                </button>
                                                <router-link :to="'/activation/' + list.id"
                                                    v-else-if="list.product_type == 'FUND_MANAGER'"
                                                    class="btn btn_red btn-block">Continue Activation</router-link>
                                                <!-- <button type="button" v-else-if="list.status == 'SUCCESS' && list.product_type == 'ROBOT'" class="btn btn_red btn-block" @click="handleRobot(list)" data-toggle="modal" data-target="#activateRobot">Activate Robot</button> -->
                                                <router-link :to="'/activation/robot/' + list.id"
                                                    v-else-if="list.status == 'SUCCESS' && list.product_type == 'ROBOT'"
                                                    class="btn btn_red btn-block">Activate Robot</router-link>
                                                <router-link :to="'/payment/' + list.id" v-else
                                                    class="btn btn_red btn-block">Complete Payment</router-link>
                                            </div>
                                        </div>
                                    </div>
                                </swiper-slide>
                            </swiper>


                            <div class="row" v-if="loading && loadingsub">
                                <div class="col-lg-4" v-for="index in 3" :key="index">
                                    <div class="card">
                                        <div class="card-body">
                                            <ContentLoader />
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <h5 class="title  mt-3">My Subscriptions</h5>
                            <h5 class="text-mude" v-if="subscriptions.length <= 0 && !loading && !loadingsub">
                                No Subscriptions Available.
                            </h5>

                            <!-- <swiper ref="subsSwiper" :options="swiperOptions" v-else-if="filterSubscription.length > 0">
                                <swiper-slide v-for="item in filterSubscription" :key="item.id" >
                                    <div class="card card_robot">
                                        <div class="card-body">
                                            <figure class="robot_img">
                                                <img :src="item.product_image" alt="">
                                            </figure>
                                            <div class="text">
                                                <h6 class="name">{{item.product_name}}</h6>

                                                <div class="row">
                                                    <div class="col-6">
                                                        <p class="info">Installation Status</p>
                                                        <p class="info_text">
                                                            <span class="badge badge-warning" v-if="item.installation_status == 'PENDING'">{{item.installation_status}}</span>
                                                            <span class="badge badge-success" v-else-if="item.installation_status == 'INSTALLED'">{{item.installation_status}}</span>
                                                            <span class="badge badge-danger" v-else>{{item.installation_status ? item.installation_status : '-'}}</span> -->
                            <!-- <span class="badge badge-warning" v-else-if="product.risk_level == 'MEDIUM'">{{product.risk_level}}</span>
                                                            <span class="badge badge-success" v-else>{{product.risk_level ? product.risk_level : '-'}}</span> -->
                            <!-- </p>
                                                    </div>
                                                    <div class="col-6">
                                                        <p class="info">Product Type</p>
                                                        <p class="info_text type_text" v-if="item.product_type == 'FUND_MANAGER'">
                                                            FUND MANAGER
                                                        </p>
                                                        <p class="info_text type_text" v-else>
                                                            {{item.product_type}}
                                                        </p>
                                                    </div>
                                                    <div class="col-6">
                                                        <p class="info">Broker</p>
                                                        <p class="info_text">
                                                            {{item.broker_name}}
                                                        </p>
                                                    </div> -->
                            <!-- <div class="col-6">
                                                        <p class="info">Risk Level</p>
                                                        <p class="info_text">
                                                            <span class="badge badge-danger" v-if="item.risk_level == 3">HIGH</span>
                                                            <span class="badge badge-warning" v-else-if="item.risk_level == 2">MEDIUM</span>
                                                            <span class="badge badge-success" v-else>LOW</span>
                                                        </p>
                                                    </div> -->
                            <!-- <div class="col-12">
                                                        <p class="info">Transaction Code :</p>
                                                        <p class="info_text type_text">{{item.transaction_code}}</p>
                                                        <p class="info">Transaction Date :</p>
                                                        <p class="info_text type_text">{{ formatDate(item.transaction_date) }}</p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="button"> -->
                            <!-- <router-link :to="'/product/'+item.id" class="btn btn_red btn-block">Complete Payment</router-link> -->
                            <!-- <router-link :to="'/payment/'+item.id" v-if="item.installation_status == 'EXPIRED'" class="btn btn_red btn-block">Renew</router-link>
                                                <button type="button" v-else class="btn btn_grey btn-block" disabled>Paid</button>

                                            </div>
                                        </div>
                                    </div>
                                </swiper-slide>
                            </swiper> -->
                            <swiper ref="subsSwiper" :options="swiperOptions" v-else-if="subscriptions.length > 0">
                                <swiper-slide v-for="item in subscriptions" :key="item.id">
                                    <div class="card card_robot">
                                        <div class="card-body">
                                            <figure class="robot_img">
                                                <img :src="item.product_image" alt="">
                                            </figure>
                                            <div class="text">
                                                <h6 class="name">{{ item.product_name }}</h6>

                                                <div class="row">
                                                    <div class="col-6">
                                                        <p class="info">Installation Status</p>
                                                        <p class="info_text">
                                                            <span class="badge badge-warning"
                                                                v-if="item.installation_status == 'PENDING'">{{
                                                                item.installation_status }}</span>
                                                            <span class="badge badge-success"
                                                                v-else-if="item.installation_status == 'INSTALLED'">{{
                                                                item.installation_status }}</span>
                                                            <span class="badge badge-danger" v-else>{{
                                                                item.installation_status ?
                                                                item.installation_status : '-'}}</span>
                                                            <!-- <span class="badge badge-warning" v-else-if="product.risk_level == 'MEDIUM'">{{product.risk_level}}</span>
                                                            <span class="badge badge-success" v-else>{{product.risk_level ? product.risk_level : '-'}}</span> -->
                                                        </p>
                                                    </div>
                                                    <div class="col-6">
                                                        <p class="info">Product Type</p>
                                                        <p class="info_text type_text"
                                                            v-if="item.product_type == 'FUND_MANAGER'">
                                                            FUND MANAGER
                                                        </p>
                                                        <p class="info_text type_text" v-else>
                                                            {{ item.product_type }}
                                                        </p>
                                                    </div>
                                                    <div class="col-6">
                                                        <p class="info">Broker</p>
                                                        <p class="info_text">
                                                            {{ item.broker_name }}
                                                        </p>
                                                    </div>
                                                    <!-- <div class="col-6">
                                                        <p class="info">Risk Level</p>
                                                        <p class="info_text">
                                                            <span class="badge badge-danger" v-if="item.risk_level == 3">HIGH</span>
                                                            <span class="badge badge-warning" v-else-if="item.risk_level == 2">MEDIUM</span>
                                                            <span class="badge badge-success" v-else>LOW</span>
                                                        </p>
                                                    </div> -->
                                                    <div class="col-12">
                                                        <p class="info">Transaction Code :</p>
                                                        <p class="info_text type_text">{{ item.transaction_code }}</p>
                                                        <p class="info">Transaction Date :</p>
                                                        <p class="info_text type_text">{{
                                                            formatDate(item.transaction_date) }}</p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="button">
                                                <!-- <router-link :to="'/product/'+item.id" class="btn btn_red btn-block">Complete Payment</router-link> -->
                                                <router-link :to="'/payment/' + item.transaction_id"
                                                    v-if="item.installation_status == 'EXPIRED'"
                                                    class="btn btn_red btn-block">Renew</router-link>
                                                <button type="button" v-else class="btn btn_grey btn-block"
                                                    disabled>Paid</button>

                                            </div>
                                        </div>
                                    </div>
                                </swiper-slide>
                            </swiper>
                            <div class="modal fade" id="activateRobot" data-backdrop="static" data-keyboard="false"
                                tabindex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
                                <div class="modal-dialog modal-dialog-centered">
                                    <div class="modal-content">
                                        <div class="modal-body">
                                            <!-- <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                                <span aria-hidden="true">&times;</span>
                                            </button> -->
                                            <div class="text-center">
                                                <h3 class="title">Activate Robot "{{ RobotName }}"</h3>
                                                <p>Please enter the Code to activate this robot!</p>
                                            </div>

                                            <form @submit.prevent="handleActivate()">
                                                <div class="mx-4">
                                                    <div v-if="submitted && message" class="alert alert-danger"
                                                        role="alert">
                                                        {{ message }}
                                                    </div>
                                                    <div v-if="submitted && success" class="alert alert-success"
                                                        role="alert">
                                                        {{ success }}
                                                    </div>
                                                    <input type="text" v-model="activation_code" v-validate="'required'"
                                                        placeholder="Enter a code.."
                                                        class="form-control text-uppercase">
                                                    <div v-if="submitted && activation_code == ''" class="text-danger">
                                                        Activation Code is Required
                                                    </div>
                                                    <div v-else-if="submitted && errors.has('activation_code')"
                                                        class="text-danger">
                                                        {{ errors.first('activation_code') }}
                                                    </div>
                                                </div>
                                                <!-- <input type="hidden" v-model="product.investor_id" class="form-control" readonly > -->
                                                <!-- <input type="hidden" v-model="product.broker_account_id" class="form-control" readonly >
                                                <input type="hidden" v-model="product.product_id" class="form-control" readonly >
                                                <input type="hidden" v-model="product.product_type" class="form-control" readonly >
                                                <input type="hidden" v-model="product.payment_amount" class="form-control" readonly >
                                                <input type="hidden" v-model="product.currency" class="form-control" readonly >
                                                <input type="hidden" v-model="product.status" class="form-control" readonly > -->
                                                <div class="row">
                                                    <div class="col-lg-6 mx-auto">
                                                        <div
                                                            class="text-center button d-flex align-items-center justify-content-center">
                                                            <button type="button" class="btn btn_grey m-2"
                                                                data-dismiss="modal"
                                                                @click="hideModal()">Cancel</button>
                                                            <button class="btn btn_red">Activate</button>
                                                            <!-- <button type="button" @click="close()" class="btn btn_grey">Ragu</button> -->
                                                            <!-- <button type="button" @click="link()" class="btn btn-secondary">Test</button> -->
                                                        </div>
                                                    </div>
                                                </div>
                                            </form>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="row" v-if="loading && loadingsub">
                                <div class="col-lg-4" v-for="index in 3" :key="index">
                                    <div class="card">
                                        <div class="card-body">
                                            <ContentLoader />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
        <!-- <dash-footer></dash-footer> -->
    </div>
</template>

<script>
import DashHeader from "../layouts/Header.vue";
// import DashFooter from "../layouts/Footer.vue";
import Sidebar from "../layouts/Sidebar.vue";
import ContentLoader from "../components/ContentLoader.vue"
import axios from 'axios'
// import moment from 'vue-moment'
import moment from 'moment'

import { Swiper, SwiperSlide, directive } from 'vue-awesome-swiper'
import 'swiper/swiper-bundle.css'

import $ from 'jquery'

export default {
    name: "AllRobot",
    directives: {
        swiper: directive
    },
    components: {
        DashHeader,
        // DashFooter,
        Sidebar,
        ContentLoader,
        Swiper,
        SwiperSlide
    },
    data() {
        return {
            subscriptions: [],
            filtersubs: [],
            transactions: [],
            pendingorder: [],
            robots: [],
            brokers: [],
            datafilter: '',
            brokerName: '',
            RobotName: '',
            loading: true,
            loadingsub: true,
            fundmanager: [],
            fundImage: '',
            transID: '',
            id: '',
            activation_code: '',
            submitted: false,
            success: '',
            message: '',
            swiperOptions: {
                slidesPerView: 3.2,
                spaceBetween: 10,
                // centeredSlides: true,
                breakpoints: {
                    320: {
                        slidesPerView: 1.2,
                        spaceBetween: 10,
                        // centeredSlides: true,
                    },
                    640: {
                        slidesPerView: 2.2,
                        spaceBetween: 10,
                    },
                    768: {
                        slidesPerView: 3.2,
                        spaceBetween: 10,
                    },
                },
                pagination: {
                    el: '.swiper-pagination',
                    type: 'progressbar'
                },
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev'
                },
            },
        }
    },
    watch: {
        // datafilter(){
        //     console.log(this.datafilter);
        // }
    },
    computed: {
        swiper() {
            return this.$refs.subsSwiper.$swiper
        },
        swiperP() {
            return this.$refs.pendSwiper.$swiper
        },
        // filterSubscription: function(){
        //     return this.subscriptions?.filter((items)=>{
        //         console.log(items);
        //         let dataitem = (items?.transaction_type?.toLowerCase().includes(this.datafilter.toLowerCase()))
        //         console.log(dataitem);
        //         return dataitem
        //     });
        // },
        filterPending: function () {
            return this.pendingorder?.filter((items) => {
                console.log(items);
                return (items?.transaction_type?.toLowerCase().includes(this.datafilter.toLowerCase()))
            });
        },
        // filterBroker(){
        //     return this.brokers.filter(broker => broker.id == 9)
        // }
    },
    async mounted() {
        this.loading = true
        this.loadingsub = true
        $('[data-widget="treeview"]').Treeview('init');
        // await axios.get(`transaction/`)
        // .then(response => {
        //     console.log('ALL transactions: ', response.data.data)
        //     this.transactions = response.data.data
        // }).catch((err) => {
        //     this.loading = false
        //     console.log('Error transactions: ', err.response)
        // })
        await axios.get(`investor/${localStorage.user_id}/subscription/`)
            .then(response => {
                // console.log('ALL subscriptions: ', response.data.data)
                setTimeout(() => {
                    this.loading = false
                    this.subscriptions = response.data.data
                    console.log(this.subscriptions);
                    // var trans = {}
                    // for (let i = 0; i < this.subscriptions.length; i++) {
                    //     console.log('Masuk For 1 ')
                    //     axios.get(`transaction/${this.subscriptions[i].transaction_id}`)
                    //     .then(response => {
                    //         console.log("Data: ", response.data.data)
                    //         this.transactions = response.data.data
                    //         // trans['id'] = response.data.data.id
                    //         // trans['transaction_code'] = response.data.data.transaction_code
                    //         // trans['created_at'] = response.data.data.created_at
                    //         // trans['broker_account_id'] = response.data.data.broker_account_id

                    //         console.log('Trans: ', trans)
                    //         this.filtersubs.push(this.transactions)

                    //     }).catch((err) => {
                    //         this.loading = false
                    //         console.log('Error transactions: ', err.response)
                    //     })
                    // }
                    // console.log('Transactions: ', this.filtersubs)
                }, 2000)


            }).catch(() => {
                this.loading = false
                // console.log('Error subscriptions: ', err.response)
            })


        await axios.get(`investor/${localStorage.user_id}/pendingorder/`)
            .then(response => {
                // console.log('ALL Pending Order: ', response.data.data)
                setTimeout(() => {
                    this.loadingsub = false
                    this.pendingorder = response.data.data
                    // var pending = response.data.data

                    // for (let j = 0; j < pending.length; j++) {
                    //     console.log('Masuk Pending For 1 ')
                    //     axios.get(`broker/`)
                    //     .then(response => {
                    //         var broker = response.data.data
                    //         for (let k = 0; k < broker.length; k++) {
                    //             if (pending[j].broker_account_id == broker[k].id) {
                    //                 // console.log('Broker by id: ', broker[k].id + broker[k].name)
                    //                 this.brokers.push(broker[k])
                    //             }
                    //         }

                    //     }).catch((err) => {
                    //         this.loading = false
                    //         console.log('Error transactions: ', err.response)
                    //     })
                    // }
                    // console.log('broker by id: ', this.brokers)
                }, 2000)
            }).catch(() => {
                this.loadingsub = false
                // console.log('Error Pending Order: ', err.response)
            })


        // await axios.get(`investor/${localStorage.user_id}/products`)
        // .then(response => {
        //     console.log('Robot All: ', response.data.data.fund_managers)
        //     var robot = response.data.data.fund_managers
        //     for (let i = 0; i < robot.length; i++) {
        //         for (let j = 0; j < this.pendingorder.length; j++) {
        //             // console.log('ID Product di Robot: ', robot[i].id)
        //             // console.log('Gambar Product di Robot: ', robot[i].image)
        //             // console.log('ID Product: ', this.pendingorder[j].product_id)
        //             if (robot[i].id === this.pendingorder[j].product_id) {
        //                 console.log('Gambar Robot: ', robot[i].image)
        //                 this.fundImage = robot[i].image
        //             }
        //         }
        //     }

        //     // console.log('Fund Manager All: ', response.data.data.fund_managers)
        //     this.fundmanager = response.data.data.fund_managers
        // }).catch((err) => {
        //     console.log('Error Robot: ', err.response)
        // })
        // await axios.get(`investor/${localStorage.user_id}/subscription/`)
        // .then(response => {
        //     console.log('ALL Subscription: ', response.data.data)
        //     this.subscriptions = response.data.data
        // }).catch((err) => {
        //     console.log('Error Subscription: ', err.response)
        // })
    },
    methods: {
        sendIdTrans(list) {
            localStorage.setItem('transaction_id', list.id)
        },
        formatPrice(val) {
            // return val.toFixed(2);
            return new Intl.NumberFormat('id-ID', { currencySign: 'accounting', maximumSignificantDigits: 2 }).format(val)
        },
        handleRobot(list) {
            this.RobotName = list.product_name
            this.transID = list.id
            this.$router.push({
                name: 'ActivateRobot',
                params: list.id
            })
            // console.log('Send Robot: ', this.RobotName + this.transID)
        },
        hideModal() {
            $('#activateRobot').modal('hide')
        },
        handleActivate() {
            this.submitted = true

            let data = new FormData()
            // data.append('id', this.transID)
            data.append('activation_code', this.activation_code)
            this.$validator.validate().then(isValid => {
                if (isValid) {
                    this.loading = true
                    axios.put(`investor/transaction/${this.transID}/activation_code`, data)
                        .then(result => {

                            // console.log('Activate: ', result)
                            this.success = result.data.message
                            setTimeout(() => {
                                $('#activateRobot').modal('hide')
                                // this.$router.push('login')
                            }, 1000)
                        }).catch((error) => {
                            this.loading = false;
                            $('#activateRobot').modal('show')
                            // console.log(error.response)
                            if (error.response.status == 404) {
                                this.message = 'Activation code is not valid!'
                            }
                        })
                } else {
                    this.loading = false
                }
            })
        },
        formatDate(value) {
            return moment(value).format('DD-MM-YYYY, h:mm:ss a');
        }
    }
}
</script>
<style scoped>
.w-select {
    width: 200px !important;
}
</style>
<style>
.content.subs .type_text {
    font-size: 10pt !important;
}

.content.subs {
    padding-bottom: 40px;
}

.content.subs .swiper-container {
    overflow-x: scroll;
}

.content.subs .swiper-container::-webkit-scrollbar {
    height: 6px;
}

.content.subs .swiper-container::-webkit-scrollbar-track {
    /* box-shadow: inset 0 0 2px grey;  */
    background: #e9e9e9;
    border-radius: 5px;
}

.content.subs .swiper-container::-webkit-scrollbar-thumb {
    background: #bdbdbd;
    border-radius: 5px;
}

.content.subs .swiper-container::-webkit-scrollbar-thumb:hover {
    background: #797979;
}
</style>